module.exports = __webpack_public_path__ + "static/media/ChildrensNational.eedaa45f.png";